import { AskConfirmation } from '../../../../webmodule-common/other/ui/modal-confirmation';
import { information } from '../../../../webmodule-common/other/ui/modal-option';
import { userDataStore } from '../../common/current-user-data-store';
import { LangBranchSwitch } from '../../../../localization/scripts/dealer-franchisee/pages/helpers/branch-switch-lang';

export async function branchSwitchOnResource(resourceBranchId: string, resourceName: string) {
  if (resourceBranchId !== userDataStore.defaultBranch.id) {
    if (userDataStore.hasBranch(resourceBranchId)) {
      const branch = userDataStore.branchById(resourceBranchId);
      if (
        await AskConfirmation(
          LangBranchSwitch.branchSwitchConfirmation({
            resourceName,
            branchName: branch.name,
            defaultBranchName: userDataStore.defaultBranch.name
          })
        )
      ) {
        //
        userDataStore.defaultBranch = branch;
      } else return false;
    } else {
      await information(LangBranchSwitch.branchSwitchNotPartOfBranch({ resourceName }));
      return false;
    }
  }
  return true;
}
